import { useNavigate } from 'react-router-dom';
import { 
  getWorkoutHistory,
  getMuscleDistribution,
  getExerciseStats,
  getOverallStats
} from '@utility/stats_utils';
import '@styles/Stats.css';
import { FaClipboardList } from "react-icons/fa";
import { AiOutlineRadarChart } from "react-icons/ai";
import { ImStatsDots } from "react-icons/im";
import { MdOutlineQueryStats } from "react-icons/md";

const Stats = () => {
  const navigate = useNavigate();

  const handleWorkoutLog = async () => {
    const history = await getWorkoutHistory();
    navigate('/home/stats_pages/workout-log', { state: { history } });
  };
  
  const handleMuscleDistribution = async () => {
    const data = await getMuscleDistribution();
    navigate('/home/stats_pages/muscle-distribution', { state: { data } });
  };
  
  const handleExerciseStats = async () => {
    const stats = await getExerciseStats();
    navigate('/home/stats_pages/exercise-stats', { state: { stats } });
  };
  
  const handleOverallStats = async () => {
    const stats = await getOverallStats();
    navigate('/home/stats_pages/overall-stats', { state: { stats } });
  };

  return (
    <div className="page-content calendar-page">
      <div className="stats-grid">
        <button className="stats-button" onClick={handleWorkoutLog}>
          <h3><FaClipboardList />Workout Log</h3>
          <p>View all your past workouts</p>
        </button>

        <button className="stats-button" onClick={handleMuscleDistribution}>
          <h3><AiOutlineRadarChart/>Muscle Distribution</h3>
          <p>See which muscles you've trained</p>
          <p>(Volume/Reps/Sets)</p>
        </button>

        <button className="stats-button" onClick={handleExerciseStats}>
          <h3><MdOutlineQueryStats/>Exercise Stats</h3>
          <p>Best volume set</p>
          <p>Heaviest weight lifted</p>
          <p>Most reps per exercise</p>
        </button>

        <button className="stats-button" onClick={handleOverallStats}>
          <h3><ImStatsDots/>Overall Stats</h3>
          <p>Total weight lifted</p>
          <p>Total reps & sets</p>
          <p>Lifetime metrics</p>
        </button>
      </div>
    </div>
  );
};

export default Stats;